/* eslint-disable no-param-reassign */
import { Button, Slide, Typography } from '@mui/material';
import VerifyEmailIcon from 'components/Icons/VerifyEmailIcon';
import VerifyPhoneIcon from 'components/Icons/VerifyPhoneIcon';
import AuthLayout from 'components/Layout/AuthLayout';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const OtpVerification = () => {
  const [verifyData, setVerifyData] = useState<any>([
    { id: 1, name: 'Email', isSelected: false },
    { id: 2, name: 'Mobile No', isSelected: false },
  ]);
  const [dataGet, setDataGet] = useState<any>('');
  const navigate = useNavigate();
  const handleVerificationMethod = (data: any) => {
    verifyData.forEach((item: any) => {
      if (item.name === data) {
        item.isSelected = true;
        setDataGet(item);
      } else {
        item.isSelected = false;
      }
    });
    setVerifyData(verifyData);
  };

  return (
    <AuthLayout>
      <>
        <Slide direction={'right'} in timeout={600}>
          <div className="mx-4 w-[532px] rounded-[12px] bg-[#FFFFFF] p-[32px]">
            <div className="mx-auto mb-4 text-center">
              <Typography
                fontWeight={600}
                variant="h5"
                color="secondary.100"
                align="center"
              >
                Choose Your OTP Verification Method
              </Typography>

              <Typography
                fontWeight={400}
                variant="subtitle1"
                color="font.900"
                align="center"
                marginTop={2}
              >
                Select Mobile or Email for One-Time Password (OTP)
                <br />
                Verification
              </Typography>
            </div>
            <div className="flex  cursor-pointer justify-center gap-6 pb-10">
              {verifyData.map((item: any) => (
                <div
                  className={
                    item.name === 'Email'
                      ? `h-auto  flex-col rounded-lg border border-solid border-primary-500 bg-primary-25 p-5 ${
                          item.isSelected
                            ? 'border-2 border-solid border-gray-500 shadow-xl'
                            : ''
                        }  hover:shadow-xl`
                      : `h-auto  flex-col items-center rounded-lg border border-solid border-primary-500 bg-primary-25 px-5 py-3 ${
                          item.isSelected
                            ? 'border-2 border-solid border-gray-500 shadow-xl'
                            : ''
                        }  hover:shadow-xl`
                  }
                  onClick={() => handleVerificationMethod(item.name)}
                >
                  <div className="h-24">
                    <div className="flex justify-center">
                      {item.name === 'Email' ? (
                        <VerifyEmailIcon />
                      ) : (
                        <VerifyPhoneIcon />
                      )}
                    </div>
                    <Typography
                      fontWeight={600}
                      variant="subtitle1"
                      color="primary"
                      align="center"
                      className={item.name === 'Email' ? 'pt-5' : 'pt-3.5'}
                    >
                      {item.name}
                    </Typography>
                  </div>
                </div>
              ))}
            </div>
            <Button
              fullWidth
              type="submit"
              className="bg-[#11AC9E] text-white"
              onClick={() => {
                navigate('/forgot-password', {
                  state: {
                    check: true,
                  },
                });
              }}
            >
              Confirm{' '}
            </Button>
          </div>
        </Slide>
      </>
    </AuthLayout>
  );
};

export default OtpVerification;
